module.exports = __webpack_public_path__ + "static/media/ic-close.5a967fa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-close.svg
// module id = 61
// module chunks = 0